// DevHub CUSTOM — i18n "catalog" namespace (card view, table view, API card view,
// and the entity details screen's About card). See ./common.ts for the convention.
import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

export const catalogMessages = createTranslationRef({
  id: 'devhub.catalog',
  messages: {
    loading: 'Loading catalog...',
    searchEntities: 'Search entities...',
    search: 'Search',
    // The catalog filters on two axes: CATEGORY (the shared 18-value taxonomy, same values
    // as the docs page and the Landscape) and KIND (Backstage's structural axis — API,
    // Component, System, Resource, Template…). Kind replaced the narrower `spec.type`
    // dropdown (service / website / library / documentation), which described only what a
    // Component is and left API entities under one meaningless option. lifecycle /
    // processingStatus / namespace / all / owner / tags were dead leftovers from the
    // retired table view.
    filters: {
      allCategories: 'All Categories',
      allKinds: 'All Kinds',
    },
    // Auto-detected documentation-vs-technical class (draeger.com/component-class). Shown as
    // the split of the "Component" option in the Kind dropdown, not a separate filter.
    componentClass: {
      documentation: 'Documentation',
      technical: 'Technical',
    },
    // Entity details screen — our own About card (EntityAboutCard). Field rows are
    // omitted when the entity has no value for them, so every key here is a label.
    about: {
      title: 'About',
      owner: 'Owner',
      contact: 'Contact',
      system: 'System',
      type: 'Type',
      lifecycle: 'Lifecycle',
      tags: 'Tags',
      category: 'Category',
      description: 'Description',
    },
    resultCountEntities: '{{filtered}} of {{total}} entities',
    resultCountEntries: '{{filtered}} of {{total}} entries',
    ownedHeading: 'Owned {{kind}}s ({{num}})',
    star: 'Star',
    unstar: 'Unstar',
    columns: {
      name: 'Name',
      system: 'System',
      owner: 'Owner',
      type: 'Type',
      lifecycle: 'Lifecycle',
      description: 'Description',
      tags: 'Tags',
      actions: 'Actions',
    },
    noEntitiesMatch: 'No entities match your filters.',
    openInNewTab: 'Open in new tab',
    edit: 'Edit',
    errorAuth: 'Unable to load the catalog — authentication failed.',
    errorGeneric: 'Failed to load catalog: {{msg}}',
    emptyTitle: 'No catalog entities available',
    emptyBody:
      'Software entities appear here once they are registered in the catalog.',
    noResultsTitle: 'No results match your filters',
    noResultsBody: 'Try broadening your search or clearing some filters.',
    footer: {
      documentation: 'Documentation',
      signIn: 'Sign In',
      copyright: '© {{year}} Drägerwerk AG & Co. KGaA. All rights reserved.',
    },
    api: {
      title: 'APIs',
      loading: 'Loading APIs...',
      search: 'Search APIs...',
      allTypes: 'All Types',
      resultCount: '{{filtered}} of {{total}} APIs',
    },
    // The "add an icon" line inside the DRAFT banner (entity page + doc reader), shown
    // while a draft still has no icon or the starter-kit placeholder. The annotation
    // snippet itself is rendered verbatim as code, so it is not a message.
    iconNudge: {
      title: 'Add an icon before publishing',
      body: 'Put an image in docs/assets/ and set this in catalog-info.yaml:',
      guide: 'How to set an icon',
      placeholderAlt: 'Placeholder icon',
    },
  },
  translations: {
    de: () => import('./de/catalog'),
  },
});
